import Profissional from "../models/Profissional";

export default class LaudoTecnico {
  constructor() {
    this.id = 0;
    this.numero = "";
    this.data = new Date();
    this.modelo = "";
    this.seguranca = "";
    this.detalhe = "Equipamento eletromecânico, alimentado por tensão trifásica de 380 V";
    this.local = "Parque Eólico de";
    this.registro = "";
    this.art = "";
    this.setor = "";
    this.empresa = { nome: "", cnpj: "", endereco: "", bairro: "", cidade: "" };
    this.solicitante = { nome: "", cnpj: "", endereco: "", bairro: "", cidade: "" };
    this.contrato = {
      tipo: "Manutenção, inspeção e certificação de equipamento.",
      inicio: new Date(),
      termino: new Date(),
      validade: "6 meses a partir da data de término do serviço.",
    };
    this.definicao = "";
    this.operacional = "";
    this.mecanica = "";
    this.eletrica = "";
    this.motor = "";
    this.recomendar = "";
    this.conclusao = "";
    this.componentes = [];
    this.normas = [];
    this.condicoes = [];
    this.riscos = [];
    this.mecanicos = [];
    this.eletricos = [];
    this.motores = [];
    this.recomendacoes = [];
    this.servicos = [];
    this.responsavel = new Profissional();
    this.rodape = "Nome do responsável - Engenheiro Mecânico - CREA ";
    //imagens carregaveis para o laudo
    this.imgFirstPage = null;
    this.imgThirdPage = null;
    //Imagens da inspeção mecânica
    this.imgFifthPageA = null;
    this.imgFifthPageB = null;
    this.imgFifthPageC = null;
    this.imgFifthPageD = null;
    //Imagens da inspeção elétrica
    this.imgSixthPageA = null;
    this.imgSixthPageB = null;
    this.imgSixthPageC = null;
    this.imgSixthPageD = null;
    //Imagens da inspeção motores
    this.imgSeventhPageA = null;
    this.imgSeventhPageB = null;
    this.imgSeventhPageC = null;
    this.imgSeventhPageD = null;
    //Tipos de inspeções usadas
    this.displayMecanica = true;
    this.displayEletrica = true;
    this.displayMotor = true;
  }
}
